module.exports = __webpack_public_path__ + "img/avatar-upload.0da0b3c3.svg";